import type { ExtensionConfig } from '@goto/shell'

import gtc from './gtc'
import meeting from './meeting'
import meetings from './meetings'
import meetingMeetNow from './meeting-meet-now'
import meetingBackgroundService from './meeting-background-service'
import voice from './voice'
import trainings from './trainings'
import webinars from './webinars'
import messaging from './messaging'
import analytics from './analytics'
import callQueuesAndContactCenter from './call-queues-and-contact-center'
import contactCenter from './contact-center'
import contactCenterAgent from './contact-center-agent'
import contactCenterSupervisor from './contact-center-supervisor'
import contactCenterWallboard from './contact-center-wallboard'
import contactCenterResolve from './contact-center-resolve'
import contactCenterSurveys from './contact-center-surveys'
import engagements from './engagements'
import engagementsOnboarding from './engagements-onboarding'
import contacts from './contacts'
import networkMeasurements from './network-measurements'

const extensionConfigs: ExtensionConfig[] = [
  gtc,
  meeting,
  meetingMeetNow,
  meetingBackgroundService,
  meetings,
  voice.mainExtension,
  voice.softphoneUIExtension,
  trainings,
  webinars,
  messaging,
  analytics,
  callQueuesAndContactCenter,
  contactCenter,
  contactCenterAgent,
  contactCenterSupervisor,
  contactCenterWallboard,
  contactCenterResolve,
  contactCenterSurveys,
  engagements,
  engagementsOnboarding,
  contacts,
  networkMeasurements,
]

export default extensionConfigs
